import { connect } from 'react-redux';
import ItemActionsBar from './ItemActionsBar';

const mapStateToProps = ({ estimateBuilder }, { itemId, isCustomerViewingCustomProduct }) => {
  const item = estimateBuilder.entities.items.byId[itemId];
  const container = estimateBuilder.entities.containers.byId[item.containerId];
  const hasProduct = !!item.itemProduct;
  const { isMandi } = estimateBuilder.entities.estimates.byId[item.designId].attributes || false;
  const invalid = hasProduct ? !item.itemProduct.isValid : false;
  const isDiscontinued = hasProduct ? item.itemProduct.productStatus === 'Discontinued' : false;

  return {
    hasProduct,
    invalid,
    isDiscontinued,
    containerHasMultipleItems: container.items.length > 1,
    canModifyItem: hasProduct && !isCustomerViewingCustomProduct,
    isMandi,
    isCustomerViewingCustomProduct,
    item,
  };
};

export default connect(mapStateToProps)(ItemActionsBar);
